import React, { useState} from 'react';
import '../../styles/Brands-p.css';


const importAll = (r) => {
  return r.keys().map(r);
};


const images = importAll(require.context('../../img/brands/emptyrooms/', false, /\.(webp|jpg|jpeg|avif)$/));

const Emptyrooms = () => {
  const [zoomedImg, setZoomedImg] = useState(null); // Estado para controlar el zoom de las imágenes

  // Función para hacer zoom en la imagen
  const handleImageClick = (image) => {
    setZoomedImg(image);
  };

  // Función para cerrar el zoom
  const handleCloseZoom = () => {
    setZoomedImg(null);
  };

  return (
    <div className="netflix-gallery">
      {/* Título y subtítulo */}
      <div className="gallery-header">
        <h1 className="gallery-title">Empty Rooms</h1>
        <h2 className="gallery-subtitle">
          <span className="agency-title">Agencia </span>  FCB México
        </h2>
        <h2 className="gallery-subtitle">
          <span className="agency-title">Productora </span> Gato
        </h2>
        <h2 className="gallery-text">In Mexico there are more than 22,000 missing women, 55% of them are minors. The Mexican Association of Stolen and Disappeared Children, created Empty Rooms/Cuartos Vacíos, a campaign that seeks dissemination, awareness and contributions to help affected families. How? Through the dissemination of rooms on property rental platforms. We encourage you to learn more about these #Empty Rooms and, of course, join the project with dissemination in the case of Zaira, Perla, Nimbe and Karla or donations for their families and AMNRDAC. Enter the Empty Rooms site and get more information → <a className="hipervinculo" href="https://cuartosvacios.mx/" target='_blank'>https://cuartosvacios.mx/</a></h2>
      </div>
      {/* Galería de imágenes */}
      <div className="brands-gallery">
        {images.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`Brand ${index}`}
            className={`brand-img img-${index % 5}`}
            onClick={() => handleImageClick(image)} // Al hacer clic, hacemos zoom
          />
        ))}
      </div>

      {/* Imagen con zoom */}
      {zoomedImg && (
        <div className="zoom-overlay" onClick={handleCloseZoom}>
          <img src={zoomedImg} alt="Zoomed" className="zoomed-img" />
        </div>
      )}
    </div>
  );
};

export default Emptyrooms;
